import { render, staticRenderFns } from "./QuitarTabContent.vue?vue&type=template&id=6cf948e6&scoped=true"
import script from "./QuitarTabContent.vue?vue&type=script&lang=js"
export * from "./QuitarTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf948e6",
  null
  
)

export default component.exports